import React from "react";
import '../assets/styles.css';

const Topbar = () => {
  return (
    <header  id="topbar" className="topbar">
      <div className="container flex-between">
      <div className="topbar-info topbar-certification">
        <p style={{
          color: '#fcf75e',
          display: 'inline-block',
          background: 'rgba(255,255,255,0.2)',
          padding: '4px 10px',
          borderRadius: '8px',
          margin: 0
        }}>ISO/IEC17025:2017 Certified</p>
        {/* <img src="assets/logo.png" alt="Geneseq Logo" height="40"> */}
      </div>
      <div className="topbar-info flex-center">
        <a href="tel:+91-99633 63021" className="topbar-link"><i className="icon-phone"></i> +91-99633 63021</a>
        <a href="mailto:info@genesequencingindia.com" className="topbar-link"><i className="icon-mail"></i> info@gsiin.com</a>
        <div className="topbar-social">
            <a href="youtube.com/genesequencingindia" title="YouTube"><i className="fab fa-youtube"></i></a>
            <a href="https://instagram.com/genesequencingindia" title="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="https://wa.me/919963363021" title="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            <a href="https://linkedin.com/in/Gene Sequencing India Private Limited" title="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
        </div>
      </div>
    </div>
    </header>
  );
}
export default Topbar;